<template>
  <div class="rich">
    <nav-bar
      @force="force"
      @setLogin="setLogin"
      @setRegister="setRegister"
    ></nav-bar>
    <div :class="isMobile ? 'm-title' : 'title'">
      <p>{{ title }}</p>
      <div class="line"></div>
      <img src="../../assets/img/bg.jpg" />
    </div>
    <div class="content" v-html="content"></div>
    <footers></footers>
    <!-- 登录弹窗 -->
    <el-dialog :visible.sync="isShowLog" :width="isMobile ? '100%' : '35%'">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <div :class="isMobile ? 'm-form' : 'p-form'">
          <p :class="isMobile ? 'm-title' : 'p-title'">{{ $t("登录") }}</p>
          <el-form-item prop="username">
            <template #label>
              <span class="label">{{ $t("电话号码") }}</span>
            </template>
            <el-input
              v-model="ruleForm.username"
              :placeholder="$t('请输入您的电话号码')"
              oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <template #label>
              <span class="label">{{ $t("密码") }}</span>
            </template>
            <el-input
              v-model="ruleForm.password"
              type="password"
              :placeholder="$t('请输入密码')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              style="width: 100%; background-color: #002fff"
              >{{ $t("登录") }}</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!-- 注册弹窗 -->
    <el-dialog :visible.sync="isShowReg" :width="isMobile ? '100%' : '35%'">
      <el-form
        :model="ruleFormReg"
        :rules="rulesd"
        ref="ruleFormReg"
        class="demo-ruleForm"
      >
        <div :class="isMobile ? 'm-form' : 'p-form'">
          <p :class="isMobile ? 'm-title' : 'p-title'">{{ $t("注册") }}</p>
          <el-form-item prop="tel">
            <template #label>
              <span class="label">{{ $t("电话号码") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.tel"
              :placeholder="$t('请输入您的电话号码')"
              oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="user_name">
            <template #label>
              <span class="label">{{ $t("姓名") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.user_name"
              :placeholder="$t('请输入您的姓名')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="pwd">
            <template #label>
              <span class="label">{{ $t("密码") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.pwd"
              type="password"
              :placeholder="$t('请输入密码')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="confirm_password">
            <template #label>
              <span class="label">{{ $t("确认密码") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.confirm_password"
              type="password"
              :placeholder="$t('请确认密码')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="depositPwd">
            <template #label>
              <span class="label">{{ $t("提款密码") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.depositPwd"
              type="password"
              :placeholder="$t('请输入提款密码')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="invite_code">
            <template #label>
              <span class="label">{{ $t("邀请码") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.invite_code"
              :placeholder="$t('请输入邀请码')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email">
            <template #label>
              <span class="label">{{ $t("邮箱") }}</span>
            </template>
            <el-input
              v-model="ruleFormReg.email"
              :placeholder="$t('请输入您的邮箱')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitFormReg('ruleFormReg')"
              style="width: 100%; background-color: #002fff"
              >{{ $t("注册") }}</el-button
            >
          </el-form-item>
          <!-- 用户协议 -->
          <div
            class="agreement"
            style="display: flex; align-items: center; justify-content: center"
          >
            <el-checkbox v-model="checked"></el-checkbox>
            <div
              style="
                color: #002fff;
                margin-left: 10px;
                text-decoration: underline;
              "
              @click="getRich"
            >
              {{ $t("用户协议") }}
            </div>
            <!-- 条款 -->
            <div
              style="
                cursor: pointer;
                color: #002fff;
                margin-left: 5px;
                text-decoration: underline;
              "
              @click="$router.push({ path: '/rich', query: { id: 2 } })"
            >
              {{ $t("条款和条件") }}
            </div>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { rich, login, register } from "../../api/index.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      content: "",
      title: "",
      isShowLog: false,
      isShowReg: false,
      ruleForm: {
        username: "",
        password: "",
      }, // 表单数据
      rules: {
        username: [
          {
            required: true,
            message: this.$t("请输入您的电话号码"),
            trigger: "blur",
          },
          // { min: 6, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t("请输入密码"), trigger: "blur" },
        ],
      }, // 校验规则
      ruleFormReg: {
        tel: "",
        user_name: "",
        pwd: "",
        confirm_password: "",
        invite_code: "",
        email: "",
        depositPwd: "",
      },
      rulesd: {
        tel: [
          {
            required: true,
            message: this.$t("请输入您的电话号码"),
            trigger: "blur",
          },
          // { min: 6, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        user_name: [
          {
            required: true,
            message: this.$t("请输入您的姓名"),
            trigger: "blur",
          },
          // { min: 6, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: this.$t("请输入密码"), trigger: "blur" },
        ],
        confirm_password: [
          { required: true, message: this.$t("请确认密码"), trigger: "blur" },
        ],
        depositPwd: [
          {
            required: true,
            message: this.$t("请输入提款密码"),
            trigger: "blur",
          },
        ],
        invite_code: [
          { required: true, message: this.$t("请输入邀请码"), trigger: "blur" },
        ],
        email: [
          {
            required: true,
            message: this.$t("请输入您的邮箱"),
            trigger: "blur",
          },
        ],
      }, // 校验规则
      checked: true, // 用户协议
    };
  },
  computed: {
    ...mapGetters("device", ["isMobile"]),
  },
  created() {
    this.getRich(this.$route.query.id);
  },
  methods: {
    // 登录弹窗
    setLogin(data) {
      this.isShowLog = data;
    },
    // 注册弹窗
    setRegister(data) {
      this.isShowReg = data;
    },
    // 登录校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 校验成功去登陆
          login({tel:this.ruleForm.username,pwd: this.ruleForm.password}).then(res=> {
            if (res.code == 0) {
              this.$message({
                message: res.info,
                type: 'success'
              })
              localStorage.setItem('token',res.token)
              localStorage.setItem('info', JSON.stringify(res.userinfo))
              setTimeout(() => {
                this.$store.dispatch('login/checkLoginType')
                this.$store.dispatch('login/checkUserInfo')
                this.$router.push('/')
              }, 2000);
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 注册校验
    submitFormReg(formName) {
      this.$refs[formName].validate((valid) => {
        console.log('valid', valid)
        if (valid) {
          // 校验成功去登陆
          register(this.ruleFormReg).then(res=> {
            if (res.code == 0) {
              this.$message({
                message: res.info,
                type: 'success'
              })
              localStorage.setItem('token',res.token)
              localStorage.setItem('info', JSON.stringify(res.userinfo))
              setTimeout(() => {
                this.$store.dispatch('login/checkLoginType')
                this.$store.dispatch('login/checkUserInfo')
                this.$router.push('/')
              }, 2000);
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getRich(id) {
      rich({ id: id }).then((res) => {
        if (res.code == 0) {
          this.title = res.data.title;
          this.content = res.data.content;
        }
      });
    },
    force(data) {
      if (data) {
        this.getRich(data);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rich {
  background-color: #fff;
  .title {
    width: 60%;
    margin: 0 auto;

    p {
      font-size: 20px;
      color: #000;
      margin-left: 30px;
      padding-top: 50px;
    }

    .line {
      width: 100%;
      height: 1px;
      background-color: #ebedf0;
      margin-bottom: 30px;
    }

    img {
      width: 100%;
    }
  }

  .content {
    width: 60%;
    margin-top: 50px;
    margin: 0 auto;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .m-title {
    padding: 10px;
    p {
      font-size: 20px;
      color: #000;
    }

    .line {
      width: 100%;
      height: 1px;
      background-color: #ebedf0;
      margin-bottom: 30px;
      display: none;
    }

    img {
      width: 100%;
    }

    .content {
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>
